<template>
    <a
        :href="funkoUrl"
        :aria-label="$t('FUNKO_HOME')"
        @click="tapLogo"
        class="cz2__funko-logos cz2__funko-logo-link"
    >
        <img
            v-if="isSplashPage"
            src="../assets/images/funko-logo-black.svg"
            :alt="$t('LOGO_FUNKO')"
            width="35"
            height="12"
        >

        <img
            v-else
            src="../assets/images/funko-logo@2x.png"
            :alt="$t('LOGO_FUNKO')"
            :class="isNameStep || isReviewStep || isCheckoutStep ? 'cz2__funko-logo-last-steps' : 'cz2__funko-logo'"
        >

        <img
            v-if="showPyLogo"
            src="../assets/images/pop-yourself-logo.svg"
            alt="Pop! Yourself Logo"
            :class="[
                {
                    'cz2__py-logo-splash': isSplashPage,
                    'cz2__py-logo-last-steps': isNameStep || isReviewStep || isCheckoutStep,
                },
            ]"
        >
    </a>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__funko-logos {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
        }

        .cz2__funko-logo-link {
            border: 1px solid transparent;

            &:focus {
                outline: none;
                border-color: #ffffff;
            }
        }

        .cz2__funko-logo-last-steps {
            width: auto;
            height: 8px;
        }

        .cz2__py-logo-splash {
            width: 68px;
            height: 60px;
        }

        .cz2__py-logo-last-steps {
            width: 51px;
            height: 45px;
        }

        @include respond-above(lg) {
            .cz2__py-logo-splash {
                width: 73px;
                height: 64px;
            }

            .cz2__funko-logo-last-steps {
                width: auto;
                height: 14px;
            }

            .cz2__py-logo-last-steps {
                width: 91px;
                height: 80px;
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__steps {
            .cz2__funko-logo--is-checkout {
                background-color: transparent;
                position: absolute;
            }

            .cz2__funko-logo-wrapper {
                position: absolute;

                margin-top: 33.35px;

                width: 100%;
                left: 0;
            }

            .cz2__funko-logo-last-steps {
                width: 188px;
                height: 64.2px;
            }
        }
    }
</style>

<script>
    export default {
        name: 'FunkoLogos',

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            isSplashPage() {
                return this.$store.state.selectedStep === 'splash' || this.$store.state.selectedStep === 'splashSelector';
            },

            currentGroupCode() {
                return this.$store.state.customizer.currentGroup?.code;
            },

            isNameStep() {
                return this.currentGroupCode === 'Name';
            },

            isReviewStep() {
                return this.currentGroupCode === 'Review';
            },

            isCheckoutStep() {
                return this.currentGroupCode === 'Checkout';
            },

            funkoUrl() {
                return this.globalSettings?.['fun-site-url'] ?? 'https://www.funko.com/';
            },

            showPyLogo() {
                return this.isSplashPage || ((this.isNameStep || this.isReviewStep || this.isCheckoutStep) && !this.isKiosk);
            },
        },

        methods: {
            tapLogo($event) {
                if (this.isKiosk) {
                    $event.preventDefault();

                    this.$store.dispatch('tapLogo');
                } else {
                    $event.preventDefault();

                    // Show exit warning modal
                    this.$store.dispatch('showExitModal', true);
                }
            },
        },
    };
</script>
